import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatbotWidget from "./components/ChatbotWidget";
import Home from "./pages/Home";
import HostingPage from "./pages/HostingPage";
import PlanRecommender from "./pages/PlanRecommender";
import DomainsPage from "./pages/DomainsPage";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ReferEarn from "./pages/ReferEarn";
import GpuServers from "./pages/GpuServers";
import NvidiaV100 from "./pages/NvidiaV100";
import NvidiaA100 from "./pages/NvidiaA100";
import NvidiaH200 from "./pages/NvidiaH200";
import RtxBlackwell from "./pages/RtxBlackwell";
import BaremetalServers from "./pages/BaremetalServers";
import ManagedServices from "./pages/ManagedServices";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import { Toaster } from "sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const MainLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <ChatbotWidget />
  </>
);

function App() {
  return (
    <div className="App" style={{ background: "#030305", minHeight: "100vh" }}>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/vps-hosting" element={<MainLayout><HostingPage category="vps" /></MainLayout>} />
          <Route path="/shared-hosting" element={<MainLayout><HostingPage category="shared" /></MainLayout>} />
          <Route path="/cloud-hosting" element={<MainLayout><HostingPage category="cloud" /></MainLayout>} />
          <Route path="/domains" element={<MainLayout><DomainsPage /></MainLayout>} />
          <Route path="/ssl" element={<MainLayout><HostingPage category="ssl" /></MainLayout>} />
          <Route path="/email-hosting" element={<MainLayout><HostingPage category="email" /></MainLayout>} />
          <Route path="/plan-recommender" element={<MainLayout><PlanRecommender /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
          <Route path="/blog" element={<MainLayout><Blog /></MainLayout>} />
          <Route path="/blog/:slug" element={<MainLayout><BlogPost /></MainLayout>} />
          <Route path="/refer" element={<MainLayout><ReferEarn /></MainLayout>} />
          <Route path="/gpu-servers" element={<MainLayout><GpuServers /></MainLayout>} />
          <Route path="/gpu/v100" element={<MainLayout><NvidiaV100 /></MainLayout>} />
          <Route path="/gpu/a100" element={<MainLayout><NvidiaA100 /></MainLayout>} />
          <Route path="/gpu/h200" element={<MainLayout><NvidiaH200 /></MainLayout>} />
          <Route path="/gpu/rtx-blackwell" element={<MainLayout><RtxBlackwell /></MainLayout>} />
          <Route path="/bare-metal" element={<MainLayout><BaremetalServers /></MainLayout>} />
          <Route path="/managed-services" element={<MainLayout><ManagedServices /></MainLayout>} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
